import { connect } from 'react-redux'
import FlowLog from './FlowLog'
import { getFlowLog, getFlows } from 'features/Flows/Flows.actions'

const stateToProps = ({ flows }, { params: { flowId, flowLogId } }) => {
  const result = flows.flowLogsById[flowLogId] || {}
  return {
    flowsById: flows.flowsById,
    flow: flows.flowsById[flowId],
    flowId,
    flowLogId,
    flowLog: result.data,
    loading: result.loading || true,
  }
}

const dispatchToProps = {
  getFlowLog,
  getFlows,
}

export default connect(stateToProps, dispatchToProps)(FlowLog)



// WEBPACK FOOTER //
// ./src/pages/FlowLog/FlowLog.container.js